import type { FC } from 'react';

import { Root, Spinner } from './styles';

export const Loader: FC = () => (
  <Root>
    <Spinner
      color="secondary"
      fontSize="large"
    />
  </Root>
);
